export default {
    init() {
        this.initTable();
        this.initModal();
        this.editCategory();
        this.saveCategory();
        this.deleteCategory();
    },
    initTable() {
        if ($('#category_table').length) {
            $('#category_table').ready(function () {
                $.ajax({
                    type: 'GET',
                    url: '/get_categories',
                    success: function (response) {
                        $('#category_table').html(response);
                        $('#category_table #table').DataTable({
                            ajax: {
                                type: 'GET',
                                url: '/get_categories_for_datatable',
                            },
                            columns: [
                                {'data': 'title'},
                                {'data': 'items'},
                                {
                                    'data': 'Action',
                                    render: function (data, type, row) {
                                        return '<div class="text-right">' +
                                            '<a href="#" class="btn text-secondary category-delete" data-id="' + row.id + '"><i class="fa fa-lg fa-trash"></i></a>' +
                                            '<a href="#" class="btn text-secondary category-edit" data-id="' + row.id + '"><i class="fa fa-lg fa-pencil"></i></a>' +
                                            '</div>';
                                    }
                                }
                            ],
                            "columnDefs": [{
                                "targets": 2,
                                "searchable": false,
                                "orderable": false
                            }]
                        });
                    }
                });
            });
        }
    },
    initModal() {
        $('.add-category').click(function () {
            $.ajax({
                type: 'GET',
                url: '/get_form_category',
                success: function (response) {
                    $('#category_form').html(response);
                    $('#category-modal').modal('show');
                }
            });
        });
    },
    editCategory() {
        $('body').on('click', '.category-edit', function (e) {
            e.preventDefault();
            $.ajax({
                type: 'GET',
                url: '/get_category',
                data: ({
                    id: $(this).data('id'),
                }),
                success: function (response) {
                    $('#category_form').html(response.view);
                    $('#category-modal').modal('show');
                }
            })
        });
    },
    saveCategory() {
        $('body').on('click', '#category-submit-form', function (e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/categories',
                data: $('#category-form').serialize(),
                success: function () {
                    $('#category-modal').modal('hide');
                    $('#category_table #table').DataTable().ajax.reload(null, false);
                },
                error: function (response) {
                    let errorsHtml = '<div class="alert alert-danger">';
                    if (response.responseJSON.error) {
                        errorsHtml += response.responseJSON.error;
                    }
                    if (response.responseJSON.errors) {
                        errorsHtml += 'Some errors occurred:<br /><ul>';

                        $.each(response.responseJSON.errors, function (index, value) {
                            errorsHtml += '<li>' + value + '</li>';
                        });
                        errorsHtml += '</ul>';
                    }
                    errorsHtml += '</div>';
                    $('.category-form-wrapper .form-validation-errors').html(errorsHtml);
                }
            });
        });
    },
    deleteCategory() {
        $('body').on('click', '.category-delete', function (e) {
            e.preventDefault();
            let elem = $(this);
            if (confirm('You sure want to delete this?')) {
                $.ajax({
                    type: 'DELETE',
                    url: '/delete_category',
                    data: ({
                        id: elem.data('id'),
                    }),
                    success: function () {
                        $('#category_table #table').DataTable().ajax.reload(null, false);
                    }
                });
            }
        });
    }
}
